

import type React from "react"

import { useState } from "react"
import { cn } from "@/lib/utils"

interface Tab {
  id: string
  label: string
  content?: React.ReactNode
}

interface ReportTabsProps {
  tabs: Tab[]
  defaultTab?: string
  className?: string
  value?: string
  onValueChange?: (tabId: string) => void
}

export function ReportTabs({
  tabs,
  defaultTab,
  className,
  value,
  onValueChange,
}: ReportTabsProps): JSX.Element {
  const [activeTab, setActiveTab] = useState(defaultTab || tabs[0]?.id)
  const currentTab = value ?? activeTab

  return (
    <div className={className}>
      <div className="flex space-x-2 mb-4">
        {tabs.map((tab) => (
          <button
            key={tab.id}
            onClick={() => {
              setActiveTab(tab.id)
              onValueChange?.(tab.id)
            }}
            className={cn(
              "px-6 py-2 rounded-lg text-lg font-medium transition-colors cursor-pointer",
              currentTab === tab.id
                ? "bg-brand-blue text-white"
                : "text-brand-blue border border-brand-blue hover:bg-brand-blue/10",
            )}
          >
            {tab.label}
          </button>
        ))}
      </div>
      <div className="mt-4">{tabs.find((tab) => tab.id === currentTab)?.content}</div>
    </div>
  )
}
